import { useTranslate } from 'b2b-apps/core/i18n/hooks';
import { Props } from './USBCharger.types';

export const USBChargerPDDescription = ({
  usbPowerDeliverySupported,
  requiredChargingPowerMin,
  requiredChargingPowerMax,
}: Pick<Props, 'usbPowerDeliverySupported' | 'requiredChargingPowerMin' | 'requiredChargingPowerMax'>): string => {
  const t = useTranslate();

  if (requiredChargingPowerMin && requiredChargingPowerMax) {
    if (usbPowerDeliverySupported) {
      return t('Supports chargers from {min} to {max} watts with USB Power Delivery', {
        min: requiredChargingPowerMin,
        max: requiredChargingPowerMax,
      });
    }

    return t('Supports chargers from {min} to {max} watts', {
      min: requiredChargingPowerMin,
      max: requiredChargingPowerMax,
    });
  }

  if (usbPowerDeliverySupported) {
    return t('Supports chargers with USB Power Delivery');
  }

  return t('Supports common USB-C chargers');
};
